import { render, staticRenderFns } from "./tableheader.vue?vue&type=template&id=2841ef9d"
import script from "./tableheader.vue?vue&type=script&lang=js"
export * from "./tableheader.vue?vue&type=script&lang=js"
import style0 from "./tableheader.vue?vue&type=style&index=0&id=2841ef9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports